export const cilChevronRight = ["24 24","<path d='M8.602 23.25l-4.559-4.56 6.711-6.711-6.711-6.711 4.559-4.56 11.273 11.268-0.53 0.535-4.027 4.027-0.003-0.003zM6.164 18.69l2.438 2.438 9.155-9.149-2.443-2.444-0.53-0.525-6.181-6.181-2.438 2.438 6.711 6.711z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chevron-right.js
// module id = null
// module chunks = 